<template>
	<div>
		<table class="table" v-for="property in properties" :key="property[0][0]">
			<tbody>
				<!-- name = property[0][0] -->
				<tr v-if="labels[property[0][0]]">
					<th scope="row" width="120px">{{labels[property[0][0]]}}</th>
					<td>
						<template v-if="property[0][0] === 'email'">
							<div v-for="email in property" :key="email[1].pref + email[3]">
								<template v-if="email[1].pref && email[1].pref === '1'">
									<strong>Preferred: <a :href="'mailto:' + email[3]">{{email[3]}}</a></strong><br>
								</template>
								<template v-else>
									<a :href="'mailto:' + email[3]">{{email[3]}}</a><br>
								</template>
							</div>
						</template>

						<template v-if="property[0][0] === 'adr'">
							{{property[0][1].label | trim}}
						</template>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ["cardArray"],
	data() {
		return {
			labels: {
				fn: "Name",
				adr: "Address",
				voice: "Phone",
				fax: "Fax",
				email: "Email"
			}
		};
	},
	computed: {
		properties() {
			const properties = {};
			this.cardArray[1].forEach(property => {
				if (
					property.length === 4 &&
					property[0] !== "version" &&
					property[0] !== "kind" &&
					property[0] !== "fn"
				) {
					const name = property[0];
					if (!properties[name]) {
						properties[name] = [];
					}
					properties[name].push(property);
				}
			});
			return properties;
		}
	},
	filters: {
		trim(value) {
			return value.replace(/\\n/g, "<br>");
		}
	}
};
</script>

<style scoped>
</style>
